import Button from 'components/Button'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import JobTypeFilter from 'modules/Roles/Partials/RolesFilter/Partials/JobTypeFilter'
import PostedOnFilter from 'modules/Roles/Partials/RolesFilter/Partials/PostedOnFilter'
import StatusFilter from 'modules/Roles/Partials/RolesFilter/Partials/StatusFilter'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Roles/Partials/RolesFilter/Styles/style'
import React, { useState } from 'react'

const { TabPane } = StyledTab

const RolesFilter = ({
  jobsList,
  searchValue,
  setSearchValue,
  filterData,
  setFilterData,
  jobTypeLevel,
  setJobTypeLevel,
  jobType,
  setJobType,
  postedDate,
  setPostedDate,
  filterStatus,
  setFilterStatus,
  setPageNum,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const submitFilter = () => {
    let selectedStatus = filterStatus[0]
    if (selectedStatus === 0) {
      selectedStatus = 0
    }
    setFilterData({
      jobType: jobType[0] || '',
      jobTypeLevel: jobTypeLevel[0] || '',
      postedOnStart: postedDate?.postedStart?.toString() || '',
      postedOnEnd: postedDate?.postedEnd?.toString() || '',
      status: selectedStatus,
    })
    setPageNum(0)
    setIsMenuOpen(false)
  }

  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)
    if (!open) {
      setJobTypeLevel([filterData?.jobTypeLevel])
      setJobType([filterData?.jobType])
      setPostedDate({
        postedStart: filterData?.postedOnStart,
        postedEnd: filterData?.postedOnEnd,
      })
      setFilterStatus([filterData?.status?.toString()])
    }
  }

  const menu = (
    <MenuFlex column className="filter">
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        padding="15px"
        popupClassName="filter"
      >
        <TabPane tab="Job Type" key="1">
          <JobTypeFilter
            jobTypeLevel={jobTypeLevel}
            setJobTypeLevel={setJobTypeLevel}
            jobType={jobType}
            setJobType={setJobType}
          />
        </TabPane>
        <TabPane tab="Posted On" key="2">
          <PostedOnFilter
            postedDate={postedDate}
            setPostedDate={setPostedDate}
          />
        </TabPane>
        <TabPane tab="Status" key="3">
          <StatusFilter
            filterStatus={filterStatus}
            setFilterStatus={setFilterStatus}
          />
        </TabPane>
      </StyledTab>
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => onCancelFilter(false)} />
        <Button.Primary onClick={submitFilter} text="Apply Filter" />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <TableSearchFilter
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      totalCount={jobsList?.count}
      currentCount={
        jobsList?.count < 10
          ? jobsList?.count
          : jobsList?.result?.length + jobsList?.page * 10
      }
      onOpenChange={onCancelFilter}
    />
  )
}

export default RolesFilter
